import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WrongDeviceComponent } from './wrong-device.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', component: WrongDeviceComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WrongDeviceRoutingModule {
}
